import React, { useRef, useState } from 'react';
import cogoToast from 'cogo-toast';
import MoneyReceiptTemplate from './MoneyReceiptTemplate';
import { exportMoneyReceiptPdfFromElement } from './MoneyReceiptReport';
import './MoneyReceiptPreviewModal.css';

const MoneyReceiptPreviewModal = ({ show, data, onClose }) => {
    const receiptRef = useRef(null);
    const [isPdfGenerating, setIsPdfGenerating] = useState(false);

    const handlePrintPdf = async () => {
        const element = receiptRef.current?.querySelector('#money-receipt-print-root');
        if (!element || !data) return;

        setIsPdfGenerating(true);
        try {
            await exportMoneyReceiptPdfFromElement(element, data);
        } catch {
            cogoToast.error('Failed to generate PDF', { position: 'bottom-center' });
        } finally {
            setIsPdfGenerating(false);
        }
    };

    if (!show || !data) return null;

    return (
        <div className="modal show-modal modalWrapper money-receipt-modal">
            <div className="modal-dialog money-receipt-modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>Money Receipt</h3>
                        <i
                            className="fa-regular fa-circle-xmark text-danger"
                            onClick={onClose}
                            role="button"
                            aria-label="Close"
                        />
                    </div>

                    <div className="modal-body money-receipt-modal-body" ref={receiptRef}>
                        <div className="money-receipt-preview-frame">
                            <MoneyReceiptTemplate data={data} />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={handlePrintPdf}
                            disabled={isPdfGenerating}
                        >
                            {isPdfGenerating ? 'Generating...' : 'Print as PDF'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                            disabled={isPdfGenerating}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MoneyReceiptPreviewModal;
